import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const AppUsers = ()=>{
    const [appUsers, setAppUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`appUsers?page=${page}`);
            setAppUsers(data.data);
            setLastPage(data.meta.last_page)
            setTotal(data.meta.total);


        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`appUsers/${id}`);
            setAppUsers(appUsers.filter((appUser) => appUser.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Customers'}>
            <InnerNav createLink={'/appUserCreate'} listLink={'/appUsers'} />
            <div className="w-full overflow-x-auto bg-white text-right leading-10 text-purple-700 pr-2">  Page <span className="rounded-full bg-purple-700 text-white p-2">{page}</span>/{lastPage} Total Records: {total} </div>
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">MinBal </th>
                                    <th className="px-4 py-3">Bal </th>
                                    <th className="px-4 py-3">CreatedAt </th>
                                    <th className="px-4 py-3">UpdatedAt </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {appUsers.map((appUser)=>{
                                         return(
                                             <tr key={appUser.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{appUser.id}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.MinBal}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.bal}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.created_at}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.updated_at}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/appUser/${appUser.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(appUser.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default AppUsers;